import React, { useEffect, useState } from "react";
import axios from "axios";


const AuthPage = (props) => {
    const [load, setLoad] = useState(false);
    const myToken = localStorage.getItem("JWT");


    //-------------------------------------------------------Auth Discord------------------------------------------//

    function discordRequest() {
        setLoad(true)

        const fragment = new URLSearchParams(window.location.hash.slice(1));
        let [accessToken, tokenType] = [
            fragment.get("access_token"),
            fragment.get("token_type"),
        ];

        axios({  // check de ses informations discord (pseudo,role,etc)
            method: "get",
            url: `https://discord.com/api/users/@me`,
            headers: {
                authorization: `${tokenType} ${accessToken}`,
            },
        })
            .then((res) => {
                let discordId = res.data.id
                let visitorPseudo = res.data.global_name;

                axios({  // envoi de ses information en Backend pour traitement
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}api/discordAuth`,
                    data: {
                        discordId,
                    },
                })
                    .then((res) => {
                        let pseudoFCU = res.data.pseudo;
                        let response = `${pseudoFCU} a reussi a se connecter`;
                        let responseStatut = 1;
                        sendLogMessage(response, responseStatut);

                        localStorage.setItem("userId", res.data.id);
                        localStorage.setItem("userPseudo", res.data.pseudo);
                        localStorage.setItem("JWT", res.data.token);


                        window.location = `/profil`;

                    })
                    .catch((err) => {
                        let response = `${visitorPseudo} a eu une erreur BackEnd ou n'est pas dans la BDD FCU ,id :${discordId} `;
                        let responseStatut = 0;
                        sendLogMessage(response, responseStatut);

                        localStorage.setItem("errorMessage", err.response.data.message);
                        window.location = `/error`;
                    });

            })
            .catch((err) => {
                let response = `un visiteur a eu un probleme de connexion (Auth Discord) `;
                let responseStatut = 0;
                sendLogMessage(response, responseStatut);

                let errorMessage = "Vous rencontrez un problème avec l'authentification discord"
                localStorage.setItem("errorMessage", errorMessage);
                window.location = `/error`;

            });
    }

    //-------------------------------------------------------Traitement des Logs------------------------------------------//

    function sendLogMessage(response, responseStatut) {
        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}api/addLog`,
            data: {
                logMessage: response,
                logType: "Connection",
                logStatut: responseStatut,
            },
        })
            .then((res) => { })
            .catch((err) => { });
    }

    //-------------------------------------------------------Vérification du token------------------------------------------//

    function checkToken() {
        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}api/verifyToken`,
            data: {
                myToken,
            },
        })
            .then((res) => {
                let userPseudo = localStorage.getItem("userPseudo");
                let response = `${userPseudo} a reussi une seconde connection`;
                let responseStatut = 1;
                sendLogMessage(response, responseStatut);

                window.location = `/profil`;
            })
            .catch((err) => {
                if (err.response.data.responseCase === 1) {

                    if (process.env.NODE_ENV === "production") {
                        window.location.href =
                          "https://discord.com/oauth2/authorize?client_id=1335709546806644797&response_type=token&redirect_uri=https%3A%2F%2Fforcecolonialeunifiee.fr%2Fauth&scope=identify";
                    } else {
                        window.location.href = "https://discord.com/oauth2/authorize?client_id=1335709546806644797&response_type=token&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fauth&scope=identify";
                    }
                } else {
                    let response = err.response.data.message;
                    let responseStatut = 0;
                    sendLogMessage(response, responseStatut);

                    localStorage.setItem("errorMessage", response);
                    window.location = `/error`;
                }
            });
    }

    useEffect(() => {

        const fragment = new URLSearchParams(window.location.hash.slice(1));        // verifier que l'url contient les informations d'auhtentification discord
        const [accessToken, tokenType] = [
            fragment.get("access_token"),
            fragment.get("token_type"),
        ];

        if (accessToken && tokenType) { // le cas ou l'authentification disord est reussi l'API prend le relais pour vérification de l'utilisateur

            discordRequest()

        } else {    // si l'auth discord n'as pas encore été faitre ( première connection), redirection vers la page d'auth discord

            if (myToken) {    // si ce n'est pas la première connection et que l'utilisateur a deja généré un token 
                checkToken()

            } else {

                if (process.env.NODE_ENV === "production") {
                    window.location.href =
                      "https://discord.com/oauth2/authorize?client_id=1335709546806644797&response_type=token&redirect_uri=https%3A%2F%2Fforcecolonialeunifiee.fr%2Fauth&scope=identify";
                } else {
                    window.location.href = "https://discord.com/oauth2/authorize?client_id=1335709546806644797&response_type=token&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fauth&scope=identify";
                }

            }
        }

    }, []);


    return (

        <div className="authPage">
            {load ?

                <div className="authPage__cont">

                    <img alt="Logo FCU" src="../../images/logoFCUBlanc.png" />
                    <span className="authPage__cont__progressBar"><span className="progressBarEffect"></span> Connexion...</span>

                </div>

                :

                <div className="authPage__cont">
                    <img alt="Logo FCU" src="../../images/logoFCUBlanc.png" />
                </div>

            }



        </div>
    );
};

export default AuthPage;